import(/* webpackMode: "eager", webpackExports: ["PasswordResetRequestSendForm"] */ "/app/apps/web/app/password-reset-requests/new/_components/password-reset-request-send-form/index.tsx");
